import React, { useState } from 'react';
import QuaTrinhLaySoLieu from './QuaTrinhLaySoLieu';
import KiemTraSoLieu from './KiemTraSoLieu';
import DuyetKiemTraSoLieu from './DuyetKiemTraSoLieu';

const SoLieuNghienCuuTab = ({ hoSoId, isAdmin }) => {
    const [activeTab, setActiveTab] = useState('quaTrinhLaySoLieu');

    if (activeTab === 'kiemTraSoLieu') {
        if (isAdmin) {
            return <DuyetKiemTraSoLieu hoSoId={hoSoId} activeTab={activeTab} setActiveTab={setActiveTab} />;
        }
        return <KiemTraSoLieu hoSoId={hoSoId} activeTab={activeTab} setActiveTab={setActiveTab} />;
    }
    
    return <QuaTrinhLaySoLieu hoSoId={hoSoId} activeTab={activeTab} setActiveTab={setActiveTab} isAdmin={isAdmin} />;
};

export default SoLieuNghienCuuTab;
